/** 左侧扩展面板默认宽度，保证提交记录图和节点列表卡片都有足够首屏空间。 */
export const VERSION_HISTORY_PANEL_DEFAULT_WIDTH = 320;

/** 左侧扩展面板最小宽度，避免拖窄后提交文字、分支图或节点卡片完全挤压。 */
export const VERSION_HISTORY_PANEL_MIN_WIDTH = 280;

/** 左侧扩展面板最大宽度，避免拖宽后过度侵占建模视口。 */
export const VERSION_HISTORY_PANEL_MAX_WIDTH = 520;

/**
 * 将左侧扩展面板宽度限制在可用范围内。
 *
 * 该函数只处理数值边界，不访问 DOM 或持久化存储，便于 Editor 事件层复用和测试。
 *
 * @param width 鼠标拖拽计算出的候选宽度。
 * @returns 经过最小/最大宽度限制后的宽度。
 */
export function resolveVersionHistoryPanelWidth(width: number): number {
  return Math.min(
    VERSION_HISTORY_PANEL_MAX_WIDTH,
    Math.max(VERSION_HISTORY_PANEL_MIN_WIDTH, width),
  );
}
